import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// GET /admin/quotations — every quotation currently pending_approval,
// oldest first (backend/src/repositories/quotationRepository.js#
// listPendingApproval already orders by submitted_at ASC). Admin-only —
// requireRole('admin') at the app.js mount point; a sales session gets a
// clean 403, never a leaked queue.
export function useApprovalQueue() {
  return useQuery({
    queryKey: ['admin', 'approvalQueue'],
    queryFn: () => apiClient.get('/admin/quotations'),
    select: (data) => data.quotations,
  });
}

export default useApprovalQueue;
